import { Game } from "./game"

interface Vehicle {
  id: number
  name: string
  icon: string
}

export const vehicleMap: Record<Game, Vehicle[]> = {
  [Game.MK8]: [
    { id: 0,  name: "Standard Kart", icon: "standard_kart" },
    { id: 1,  name: "Pipe Frame", icon: "pipe_frame" },
    { id: 2,  name: "Mach 8", icon: "mach_8" },
    { id: 3,  name: "Steel Driver", icon: "steel_driver" },
    { id: 4,  name: "Cat Cruiser", icon: "cat_cruiser" },
    { id: 5,  name: "Circuit Special", icon: "circuit_special" },
    { id: 6,  name: "Tri-Speeder", icon: "tri_speeder" },
    { id: 7,  name: "Badwagon", icon: "badwagon" },
    { id: 8,  name: "Prancer", icon: "prancer" },
    { id: 9,  name: "Biddybuggy", icon: "biddybuggy" },
    { id: 10, name: "Landship", icon: "landship" },
    { id: 11, name: "Sneeker", icon: "sneeker" },
    { id: 12, name: "Sports Coupe", icon: "sports_coupe" },
    { id: 13, name: "Gold Standard", icon: "gold_standard" },
    { id: 14, name: "Standard Bike", icon: "standard_bike" },
    { id: 15, name: "Comet", icon: "comet" },
    { id: 16, name: "Sport Bike", icon: "sport_bike" },
    { id: 17, name: "The Duke", icon: "the_duke" },
    { id: 18, name: "Flame Rider", icon: "flame_rider" },
    { id: 19, name: "Varmint", icon: "varmint" },
    { id: 20, name: "Mr. Scooty", icon: "mr_scooty" },
    { id: 21, name: "Jet Bike", icon: "jet_bike" },
    { id: 22, name: "Yoshi Bike", icon: "yoshi_bike" },
    { id: 23, name: "Standard ATV", icon: "standard_atv" },
    { id: 24, name: "Wild Wiggler", icon: "wild_wiggler" },
    { id: 25, name: "Teddy Buggy", icon: "teddy_buggy" },
    { id: 26, name: "GLA", icon: "gla" },
    { id: 27, name: "W 25 Silver Arrow", icon: "w_25_silver_arrow" },
    { id: 28, name: "300 SL Roadster", icon: "300_sl_roadster" },
    { id: 29, name: "Blue Falcon", icon: "blue_falcon" },
    { id: 30, name: "Tanooki Kart", icon: "tanooki_kart" },
    { id: 31, name: "B Dasher", icon: "b_dasher" },
    { id: 32, name: "Master Cycle", icon: "master_cycle" },
    { id: 35, name: "Streetle", icon: "streetle" },
    { id: 36, name: "P-Wing", icon: "p_wing" },
    { id: 37, name: "City Tripper", icon: "city_tripper" },
    { id: 38, name: "Bone Rattler", icon: "bone_rattler" },
  ],
  [Game.MK8DX]: [
    { id: 0,  name: "Standard Kart", icon: "standard_kart" },
    { id: 1,  name: "Pipe Frame", icon: "pipe_frame" },
    { id: 2,  name: "Mach 8", icon: "mach_8" },
    { id: 3,  name: "Steel Driver", icon: "steel_driver" },
    { id: 4,  name: "Cat Cruiser", icon: "cat_cruiser" },
    { id: 5,  name: "Circuit Special", icon: "circuit_special" },
    { id: 6,  name: "Tri-Speeder", icon: "tri_speeder" },
    { id: 7,  name: "Badwagon", icon: "badwagon" },
    { id: 8,  name: "Prancer", icon: "prancer" },
    { id: 9,  name: "Biddybuggy", icon: "biddybuggy" },
    { id: 10, name: "Landship", icon: "landship" },
    { id: 11, name: "Sneeker", icon: "sneeker" },
    { id: 12, name: "Sports Coupe", icon: "sports_coupe" },
    { id: 13, name: "Gold Standard", icon: "gold_standard" },
    { id: 14, name: "Standard Bike", icon: "standard_bike" },
    { id: 15, name: "Comet", icon: "comet" },
    { id: 16, name: "Sport Bike", icon: "sport_bike" },
    { id: 17, name: "The Duke", icon: "the_duke" },
    { id: 18, name: "Flame Rider", icon: "flame_rider" },
    { id: 19, name: "Varmint", icon: "varmint" },
    { id: 20, name: "Mr. Scooty", icon: "mr_scooty" },
    { id: 21, name: "Jet Bike", icon: "jet_bike" },
    { id: 22, name: "Yoshi Bike", icon: "yoshi_bike" },
    { id: 23, name: "Standard ATV", icon: "standard_atv" },
    { id: 24, name: "Wild Wiggler", icon: "wild_wiggler" },
    { id: 25, name: "Teddy Buggy", icon: "teddy_buggy" },
    { id: 26, name: "GLA", icon: "gla" },
    { id: 27, name: "W 25 Silver Arrow", icon: "w_25_silver_arrow" },
    { id: 28, name: "300 SL Roadster", icon: "300_sl_roadster" },
    { id: 29, name: "Blue Falcon", icon: "blue_falcon" },
    { id: 30, name: "Tanooki Kart", icon: "tanooki_kart" },
    { id: 31, name: "B Dasher", icon: "b_dasher" },
    { id: 32, name: "Master Cycle", icon: "master_cycle" },
    { id: 33, name: "Streetle", icon: "streetle" },
    { id: 34, name: "P-Wing", icon: "p_wing" },
    { id: 35, name: "City Tripper", icon: "city_tripper" },
    { id: 36, name: "Bone Rattler", icon: "bone_rattler" },
    { id: 37, name: "Koopa Clown", icon: "koopa_clown" },
    { id: 38, name: "Splat Buggy", icon: "splat_buggy" },
    { id: 39, name: "Inkstriker", icon: "inkstriker" },  
    { id: 40, name: "Master Cycle Zero", icon: "master_cycle_zero" },  
  ],
}